// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3693":"c06ad82fce9f23db","5641":"4dfa2e3f2030ae9f"}[chunkId] + ".css";
};